import "./ladzo.less";

import { LadzoConsole as Lc } from "./js/global/ladzo-console.js";
import { Top } from "./js/class/Top.js";
import { MojeFce as Fce } from "./js/global/fce.js";
import * as cookie from "./js/incl/cookie_lista.js";
import * as nav from "./js/incl/navigace.js";
import * as zahlavi from "./js/incl/zahlavi.js";
import * as clientContact from "./js/page/client_contact.js";
import * as delivery from "./js/page/delivery.js";

import { initShowPasswordToggle } from "./js/global/showPasswordToggle.js";
//import * as scroll from "./js/incl/scrollWatcher.js";

Top.nodeServer = window.ladzoNodeServer || false;

var Url = new URL(window.location.href);
Top.localhost = false;

let debug = Fce.get(window, "debug") || false;

if (
  process.env.NODE_ENV == "development" ||
  Url.searchParams.has("debug") ||
  debug
) {
  Lc.zobraz({ version: "1.0.0.004", appName: "reklamni.predmety.cz" });
}
if (process.env.NODE_ENV == "development") {
  Top.localhost = true;
  Top.filtrySkladem = true;

  let b = Fce.get(window, "Ladzo.localhost") || false;
  if (!b) Top.localhost = false;
}
window.addEventListener("load", function () {
  cookie.zobrazCookieListu();
  //nn(2);
});

window.nn = function (index) {
  // vybere první ul uvnitř .main-menu a v něm nth-li
  $(".main-menu > ul > li").removeClass("is-open");
  $(".main-menu > ul > li").eq(index).addClass("is-open");
};

$(function () {
  nav.zobrazNavigaci();

  zahlavi.zah_dropdownKlient();
  let Dl = Fce.getDataLayer();
  Lc.log("Dl", Dl);

  let bodyId = $("body").attr("id");

  if (bodyId == "bdUvod") {
    //uprava pro carousel
    $("#dvCarousel").on("init", function (event, slick) {
      $(this).removeClass("non");
    });
  } else if (bodyId == "bdKlientContact") {
    clientContact.upravStranku();
  } else if ($("body").hasClass("bdDelivery")) {
    delivery.upravStranku();
  }

  // přepínač viditelnosti hesla
  initShowPasswordToggle(".inptOko");

  //$("html").addClass("htmlNavig");

  /*
  scroll.watchScrollFix("#aMenu", {
    offset: 50, // třeba 50px
    className: "fixed", // třída co se přidá
  });
  */
});
